import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6989efa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "portal-home-list" }
const _hoisted_2 = { class: "portal-home-list-head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "portal-home-list-head-title" }, "项目列表", -1))
const _hoisted_4 = { class: "portal-home-list-head-filter" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 全部 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 进行中 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 已结束 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 已过期 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 已冻结 ")
const _hoisted_10 = { class: "portal-home-list-head-filter-search" }
const _hoisted_11 = {
  key: 0,
  class: "portal-home-list-empty"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "portal-home-list-footer" }, "*患者数和项目数统计量截止当天0点", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_HomeProject = _resolveComponent("HomeProject")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_a_radio_group, {
          value: _ctx.filter.status,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.status) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getProjectList(false)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_radio_button, { value: "ALL" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "IN_PROGRESS" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "COMPLETE" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "EXPIRED" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_a_radio_button, { value: "FROZEN" }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_a_input_search, {
            value: _ctx.filter.name,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filter.name) = $event)),
            placeholder: "搜索项目",
            onSearch: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getProjectList(false)))
          }, null, 8, ["value"])
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (project) => {
      return (_openBlock(), _createBlock(_component_HomeProject, {
        key: project.projectVo.project.id,
        project: project,
        onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getProjectList(false))),
        onGoCustom: _ctx.goCustom
      }, null, 8, ["project", "onGoCustom"]))
    }), 128)),
    (_ctx.list.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, "暂无数据"))
      : _createCommentVNode("", true),
    _hoisted_12
  ]))
}